import React from 'react';
import classNames from 'classnames';

import css from './ListingPage.module.css';


const ShareIcon = () => {
  return (
    <svg className={classNames(css.sociaIcon, css.shareIcon)} width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4172 20.772C15.4164 20.1795 15.575 19.5979 15.8762 19.0877L8.30551 14.6784C8.01266 15.1814 7.59322 15.5985 7.08861 15.8885C6.58399 16.1785 6.01214 16.3312 5.43013 16.3311C4.54694 16.3307 3.69958 15.9798 3.07507 15.3553C2.45057 14.7308 2.09996 13.8837 2.09961 13.0005C2.09996 12.1175 2.45117 11.2708 3.07572 10.6465C3.70026 10.0222 4.54706 9.67132 5.43013 9.67132C6.01233 9.67106 6.58441 9.82354 7.08925 10.1135C7.59409 10.4035 8.01373 10.8209 8.3068 11.324L15.871 6.90827C15.5733 6.3993 15.4164 5.82006 15.4172 5.23042C15.4173 4.79288 15.5039 4.35957 15.6715 3.95541C15.8391 3.55125 16.0844 3.18398 16.3939 2.87472C16.7034 2.56546 17.0709 2.32024 17.4752 2.15297C17.8795 1.98569 18.3127 1.89973 18.7503 1.8999C19.1876 1.8999 19.6206 1.9859 20.0246 2.15329C20.4286 2.32068 20.7955 2.56609 21.1047 2.87536C21.4138 3.18464 21.6592 3.55199 21.8264 3.95606C21.9936 4.36012 22.0797 4.79312 22.0795 5.23042C22.0797 5.66766 21.9937 6.10047 21.8264 6.50446C21.6592 6.90845 21.4138 7.27565 21.1047 7.58483C20.7955 7.894 20.4286 8.13901 20.0246 8.30626C19.6206 8.4735 19.1875 8.5595 18.7503 8.55932C18.1678 8.55965 17.5957 8.40748 17.0905 8.11775C16.5852 7.82801 16.1649 7.41111 15.871 6.90827L8.3068 11.324C8.60358 11.8328 8.76002 12.4115 8.75935 13.0005C8.76032 13.5898 8.60341 14.1687 8.30551 14.6771L15.8762 19.0864C16.1695 18.5845 16.5894 18.1682 17.0937 17.8792C17.598 17.5901 18.169 17.4383 18.7503 17.4389C19.1877 17.4389 19.6212 17.5251 20.0253 17.6926C20.4293 17.8601 20.7961 18.1056 21.1053 18.415C21.4145 18.7244 21.6599 19.0918 21.8271 19.496C21.9942 19.9002 22.0798 20.3333 22.0795 20.7707C22.0795 21.6536 21.729 22.5004 21.1047 23.1248C20.4803 23.7491 19.6332 24.0999 18.7503 24.0999C17.8671 24.1003 17.0202 23.7497 16.3952 23.1257C15.7702 22.5017 15.4182 21.6552 15.4172 20.772V20.772Z" stroke="#2F4E1E" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  )
}
const FaceBookIcon = () => {
  return (
    <svg className={css.sociaIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="3" fill="#395185"/>
      <rect x="6" y="3" width="10" height="14" rx="3" fill="white"/>
      <path d="M9.9999 0.400024C4.6979 0.400024 0.399902 4.69802 0.399902 10C0.399902 15.302 4.6979 19.6 9.9999 19.6C15.3019 19.6 19.5999 15.302 19.5999 10C19.5999 4.69802 15.3019 0.400024 9.9999 0.400024ZM12.2739 7.03402H10.8309C10.6599 7.03402 10.4699 7.25902 10.4699 7.55802V8.60003H12.2749L12.0019 10.086H10.4699V14.547H8.7669V10.086H7.2219V8.60003H8.7669V7.72602C8.7669 6.47202 9.6369 5.45302 10.8309 5.45302H12.2739V7.03402Z" fill="#395185"/>
    </svg>
  )
}
const WhatsAppIcon = () => {
  return (
    <svg className={css.sociaIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="3" fill="#65BB47"/>
      <path d="M15.1226 4.89729C13.9182 3.66759 12.2534 3 10.5531 3C6.94009 3 4.03544 5.91621 4.07084 9.46484C4.07084 10.5892 4.38964 11.6784 4.92101 12.6622L4 16L7.43596 15.1216C8.39236 15.6487 9.45499 15.8946 10.5177 15.8946C14.0954 15.8946 17 12.9784 17 9.42979C17 7.70813 16.3269 6.09189 15.1226 4.89729ZM10.5531 14.8055C9.59672 14.8055 8.64032 14.5596 7.8256 14.0676L7.61308 13.9622L5.5586 14.4892L6.08992 12.4866L5.94824 12.2757C4.38964 9.78116 5.13352 6.47837 7.68392 4.9324C10.2343 3.38648 13.5286 4.12433 15.0872 6.65406C16.6458 9.18378 15.9019 12.4514 13.3515 13.9973C12.5368 14.5243 11.545 14.8055 10.5531 14.8055ZM13.6703 10.9055L13.2806 10.7298C13.2806 10.7298 12.7139 10.4839 12.3597 10.3082C12.3242 10.3082 12.2888 10.273 12.2534 10.273C12.1471 10.273 12.0763 10.3082 12.0054 10.3433C12.0054 10.3433 11.97 10.3784 11.4741 10.9406C11.4387 11.0109 11.3678 11.046 11.297 11.046H11.2616C11.2262 11.046 11.1553 11.0109 11.1199 10.9758L10.9428 10.9055C10.5531 10.7298 10.1989 10.519 9.91552 10.2379C9.84468 10.1676 9.73839 10.0974 9.66756 10.0271C9.4196 9.78116 9.17163 9.50005 8.99456 9.18384L8.95912 9.11357C8.92372 9.07841 8.92372 9.04331 8.88828 8.97304C8.88828 8.90278 8.88828 8.83251 8.92372 8.79735C8.92372 8.79735 9.0654 8.62167 9.17163 8.5163C9.24252 8.44598 9.27792 8.34061 9.34876 8.27035C9.41959 8.16492 9.45504 8.02439 9.41959 7.91897C9.3842 7.74329 8.95912 6.79464 8.85289 6.58384C8.782 6.47842 8.71121 6.44332 8.60492 6.40816H8.21529C8.1444 6.40816 8.07361 6.44332 8.00272 6.44332L7.96727 6.47842C7.89644 6.51358 7.8256 6.58384 7.75476 6.61895C7.68392 6.68927 7.64847 6.75948 7.57764 6.8298C7.32967 7.14601 7.188 7.53249 7.188 7.91897C7.188 8.20003 7.25884 8.48114 7.36512 8.72709L7.40056 8.83251C7.71936 9.50005 8.1444 10.0974 8.71121 10.6244L8.85289 10.7649C8.95912 10.8703 9.0654 10.9406 9.13624 11.046C9.88012 11.6785 10.7302 12.1352 11.6866 12.3811C11.7929 12.4163 11.9346 12.4163 12.0409 12.4514H12.3951C12.5722 12.4514 12.7847 12.3811 12.9264 12.3109C13.0327 12.2406 13.1035 12.2406 13.1744 12.1704L13.2452 12.1C13.3161 12.0298 13.3869 11.9947 13.4578 11.9244C13.5286 11.8541 13.5994 11.7839 13.6349 11.7136C13.7057 11.573 13.7411 11.3973 13.7766 11.2217V10.9758C13.7766 10.9758 13.7411 10.9406 13.6703 10.9055Z" fill="white"/>
    </svg>
  )
}
const GoogleIcon = () => {
  return (
    <svg className={classNames(css.sociaIcon, css.googleIcon)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="3" fill="#4285F4"/>
      <g clipPath="url(#clip0_2126_1198)">
        <path d="M15.8512 5.00098C16.482 5.00098 16.9981 5.51045 16.9981 6.13311V6.46132L15.4047 7.58488L9.97997 11.2736L4.55521 7.54746V14.9995H4.14691C3.51613 14.9995 3 14.49 3 13.8674V6.13343C3 5.51076 3.51613 5.00128 4.14691 5.00128L9.97997 9.27036L15.8509 5.00128L15.8512 5.00098Z" fill="#E75A4D"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint0_linear_2126_1198)"/>
        <path d="M4.55518 7.54724V14.9993H15.405V7.58466L9.97993 11.2734L4.55518 7.54724Z" fill="white"/>
        <path d="M4.55518 14.9993L9.97993 11.2734L9.95538 11.2562L4.55518 14.9174V14.9993Z" fill="#B8B7AE"/>
        <path d="M15.405 7.58459L15.4081 14.9992L9.97998 11.2733L15.405 7.58459Z" fill="#EBEBEB"/>
        <path d="M16.9981 6.46112L17 13.8681C16.9727 14.6913 16.6113 14.9852 15.4081 14.999L15.405 7.58437L16.9985 6.46082L16.9981 6.46112Z" fill="#B2392F"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint1_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint2_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint3_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint4_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint5_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint6_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="url(#paint7_linear_2126_1198)"/>
        <path d="M4.14697 5.00073L9.98003 9.26981L15.8513 5.00073H4.14697Z" fill="white"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint1_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint2_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint3_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint4_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint5_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint6_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <linearGradient id="paint7_linear_2126_1198" x1="6.25283" y1="7.13564" x2="13.7312" y2="7.13564" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F8F6EF"/>
        <stop offset="1" stopColor="#E7E4D6"/>
        </linearGradient>
        <clipPath id="clip0_2126_1198">
        <rect width="14" height="10" fill="white" transform="translate(3 5)"/>
        </clipPath>
      </defs>
    </svg>

    // <svg className={classNames(css.sociaIcon, css.googleIcon)} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <rect x="1" y="1" width="20" height="20" rx="3" fill="#EA4335"/>
    //   <rect x="4" y="6" width="14" height="12" rx="3" fill="white"/>
    //   <path d="M11 1.375C5.68477 1.375 1.375 5.68477 1.375 11C1.375 16.3152 5.68477 20.625 11 20.625C16.3152 20.625 20.625 16.3152 20.625 11C20.625 5.68477 16.3152 1.375 11 1.375ZM11.7842 13.3805C10.841 14.7082 8.94609 15.0949 7.46797 14.5256C5.98555 13.9605 4.93281 12.3943 5.05957 10.798C5.0918 8.84512 6.89004 7.13281 8.84297 7.19941C9.77969 7.15645 10.6605 7.5625 11.3781 8.13613C11.0709 8.48418 10.7551 8.81934 10.4156 9.13086C9.5541 8.53574 8.32734 8.36602 7.46582 9.05352C6.23262 9.90645 6.17676 11.9195 7.3627 12.8369C8.51641 13.8832 10.6971 13.3633 11.0172 11.7605C10.2953 11.7498 9.56914 11.7605 8.84727 11.7369C8.84512 11.3051 8.84297 10.8754 8.84512 10.4436C10.0525 10.4393 11.2621 10.4371 12.4717 10.4479C12.5426 11.4641 12.4072 12.5426 11.7842 13.3805ZM16.9941 11.5264C16.6332 11.5307 16.2723 11.5328 15.9113 11.535C15.907 11.8959 15.9049 12.2568 15.9049 12.6178H14.8242C14.8199 12.2568 14.8199 11.898 14.8178 11.5371C14.4568 11.5328 14.0959 11.5307 13.735 11.5264V10.45C14.0959 10.4457 14.4568 10.4436 14.8178 10.4436C14.8199 10.0826 14.8242 9.72168 14.8264 9.36074H15.9049L15.9113 10.4436C16.2723 10.4479 16.6332 10.4479 16.9941 10.45V11.5264Z" fill="#EA4335"/>
    // </svg>
  )
}
const CopyLinkIcon = () => {
  return (
    <svg className={css.sociaIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6665 6.66663H3.33317C2.414 6.66663 1.6665 7.41413 1.6665 8.33329V16.6666C1.6665 17.5858 2.414 18.3333 3.33317 18.3333H11.6665C12.5857 18.3333 13.3332 17.5858 13.3332 16.6666V8.33329C13.3332 7.41413 12.5857 6.66663 11.6665 6.66663Z" fill="#2F4E1E"/>
      <path d="M16.6665 1.66663H8.33317C7.89114 1.66663 7.46722 1.84222 7.15466 2.15478C6.8421 2.46734 6.6665 2.89127 6.6665 3.33329V4.99996H13.3332C13.7752 4.99996 14.1991 5.17555 14.5117 5.48811C14.8242 5.80068 14.9998 6.2246 14.9998 6.66663V13.3333H16.6665C17.1085 13.3333 17.5325 13.1577 17.845 12.8451C18.1576 12.5326 18.3332 12.1087 18.3332 11.6666V3.33329C18.3332 2.89127 18.1576 2.46734 17.845 2.15478C17.5325 1.84222 17.1085 1.66663 16.6665 1.66663Z" fill="#2F4E1E"/>
    </svg>
  )
}


const ShareListing = () => {

  const isWindowDefined = typeof window !== 'undefined';

  if(!isWindowDefined) {
    return null
  }

  const socials = [
    {
      name: "copylink",
      icon: <CopyLinkIcon />,
      link: window.location.href,
      isCopy: true,
    },
    {
      name: "facebook",
      icon: <FaceBookIcon />,
      link: `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
      isCopy: false,
    },
    {
      name: "whatsapp",
      icon: <WhatsAppIcon />,
      link: `https://wa.me/?text=${window.location.href}`,
      isCopy: false,
    },
    {
      name: "google",
      icon: <GoogleIcon />,
      link: `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Wacampa Listing&body=${window.location.href}&ui=2&tf=1&pli=1`,
      isCopy: false,
    },
  ];

  const handleOpenSocial = (url, isCopy) => {
    if (isCopy) {
      navigator.clipboard.writeText(url);
    } else {
      window.open(url, '_blank');
    }
  }

  return (
    <div className={css.shareSocialsContainer}>
      <div className={css.shareIconContainer}>
        <ShareIcon />
      </div>
      <div className={css.shareSocialsListWrapper}>
        <ul className={css.shareSocialsList}>
          {socials.map(({name, icon, link, isCopy}) => {
            return (
              <li
                key={name}
                onClick={() => handleOpenSocial(link, isCopy)}
                className={css.shareSocialsListItem}
              >
                {icon}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

export default ShareListing;
